import axios from 'axios';
import React, { Component, Fragment } from 'react';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import Cropper from 'react-easy-crop';
import Loading from 'components/Loading/Loading';
import { connect } from 'react-redux';
import { updateProfile } from 'actions/userActions';

import getCroppedImg from './cropImage';


import './style.css';

function readFile(file) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.addEventListener('load', () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
}

async function blobFromObjectUrl(objectUrl, onLoad) {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', objectUrl, true);
  xhr.responseType = 'blob';
  xhr.onload = function () {
    if (this.status === 200) {
      const myBlob = this.response;
      onLoad(myBlob);
    }
  };
  xhr.send();
}

function mapStateToProps(state) {
  return {
    user: state.user
  };
}

class TeacherSettingsPhoto extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageSrc: null,
      crop: { x: 0, y: 0 },
      zoom: 1,
      aspect: 1,
      croppedAreaPixels: null,
      croppedImage: null,
      uploading: null,
      success: null
    };
  }

  onCropChange = (crop) => {
    this.setState({ crop });
  }

  onCropComplete = (croppedArea, croppedAreaPixels) => {
    this.setState({ croppedAreaPixels });
  }

  onZoomChange = (zoom) => {
    this.setState({ zoom });
  }

  onFileChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const imageDataUrl = await readFile(e.target.files[0]);
      this.setState({
        imageSrc: imageDataUrl,
        crop: { x: 0, y: 0 },
        zoom: 1,
        croppedAreaPixels: null,
        croppedImage: null,
        uploading: null,
        success: null
      });
    }
  }

  // First letter of the environment, user id, and the timestamp we try to upload
  makeFileName = (ext) => {
    return `${process.env.REACT_APP_ENV[0]}-${
      this.props.user.profile.id
    }-${new Date().getTime()}.${ext}`;
  }

  upload = () => {
    this.setState({ uploading: true, success: null });
    const file = this.fileUpload.files[0];
    const fileType = file.name.split('.').pop();
    const fileName = this.makeFileName(fileType);

    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/s3/sign`,
        {
          fileName,
          fileType
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.props.user.token}`
          }
        }
      )
      .then(response => {
        const { returnData } = response.data.data;
        const { signedRequest } = returnData;
        const options = {
          headers: {
            'Content-Type': fileType
          }
        };
        blobFromObjectUrl(this.state.croppedImage, async blob => {
          axios
            .put(signedRequest, new File([blob], fileName), options)
            .then(() => {
              this.props.updateProfile({ picture: { url: returnData.url } }, false, () => {
                this.setState({ uploading: null, success: true, imageSrc: null });
              });
            })
            .catch(error => {
              this.setState({ error: JSON.stringify(error), uploading: null, success: false });
              alert('ERROR uploading your photo');
            });
        });
      })
      .catch(error => {
        alert('ERROR uploading your photo');
        this.setState({ error: JSON.stringify(error), uploading: null, success: false });
      });
  }

  cancel = () => {
    this.setState({ croppedImage: null, croppedAreaPixels: null });
  }

  showCroppedImage = async () => {
    const croppedImage = await getCroppedImg(this.state.imageSrc, this.state.croppedAreaPixels);
    this.setState({ croppedImage });
  }

  render() {
    const { picture } = this.props.user.profile;
    let pictureUrl = picture ? picture.url : null;
    if (pictureUrl) {
      pictureUrl = pictureUrl.replace(/^https:\/\//i, 'http://');
    }

    return (
      <div className="teacher-profile-photo">
        <h4 className="mb-4">Change Your Profile Photo</h4>
        <div className="choose-file">
          <input
            type="file"
            accept="image/*"
            onChange={this.onFileChange}
            // eslint-disable-next-line no-return-assign
            ref={ref => (this.fileUpload = ref)}
          />
        </div>

        {!this.state.imageSrc && pictureUrl && <img alt="" className="result-image" src={pictureUrl} />}

        {this.state.imageSrc && (
          <Fragment>
            {this.state.croppedImage && (
              <div className="cropped-result">
                <img alt="" className="result-image" src={this.state.croppedImage} />
                <div className="result-actions mt-2">
                  {this.state.uploading && (
                    <div>
                      <div>
                        <strong>Uploading...please do not close or refresh this page</strong>
                      </div>
                      <Loading size="small" />
                    </div>
                  )}
                  {!this.state.uploading && (
                    <Fragment>
                      <button
                        type="button"
                        className="btn btn-primary btn-cursor btn-lg mr-1"
                        onClick={this.upload}
                      >
                        UPLOAD
                      </button>
                      <button type="button" className="btn btn-primary btn-cursor btn-lg" onClick={this.cancel}>
                        CANCEL
                      </button>
                    </Fragment>
                  )}
                </div>
              </div>
            )}
            {!this.state.croppedImage && (
              <Fragment>
                <div className="crop-container">
                  <Cropper
                    image={this.state.imageSrc}
                    crop={this.state.crop}
                    zoom={this.state.zoom}
                    aspect={this.state.aspect}
                    onCropChange={this.onCropChange}
                    onCropComplete={this.onCropComplete}
                    onZoomChange={this.onZoomChange}
                  />
                </div>
                <div className="controls">
                  <ReactBootstrapSlider
                    value={this.state.zoom}
                    min={1}
                    max={3}
                    step={0.1}
                    aria-labelledby="Zoom"
                    change={e => this.onZoomChange(e.target.value)}
                    tooltip_split
                    tooltip="hide"
                  />
                </div>
                <div className="crop-button-container">
                  <button
                    type="button"
                    className="btn btn-primary btn-cursor btn-lg"
                    onClick={this.showCroppedImage}
                  >
                    CROP
                  </button>
                </div>
              </Fragment>
            )}
          </Fragment>
        )}
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  { updateProfile }
)(TeacherSettingsPhoto);



// WEBPACK FOOTER //
// ./src/pages/teacher/Settings/Photo/index.js